import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TitleService } from '../../common/services/title/title.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppStateService } from '../../common/services/app-state/app-state.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Component({
    selector: 'cas-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    public loginForm: FormGroup;
    private isRetry: boolean;

    constructor(
        private deviceService: DeviceDetectorService,
        private titleService: TitleService,
        private oauthService: OAuthService,
        appStateService: AppStateService // This import is needed for banner subscriptions
    ) {
    }

    public ngOnInit() {
        this.loginForm = new FormGroup({});
        this.titleService.setTitleIfEmpty('Login');
    }

    public async onSubmit() {
        if(environment.employeeSite)
        {
            window.location.href = environment.employeeLoginUrl;
            return;
        }
        if (!this.oauthService.jwks || this.isRetry) {
            // If we are missing data from the discovery document, then try loading it before login.
            await this.oauthService.loadDiscoveryDocument();
        }
        this.oauthService.initLoginFlow();

        // If we reached here the first login attempt failed for some reason, so force reloading discovery information on future login attempts
        this.isRetry = true;
    }

    public isDesktop() {
        const userAgent = window.navigator.userAgent;
        return this.deviceService.isDesktop(userAgent);
    }

    public get copyright() {
        const year = new Date().getFullYear();
        return `CaptiveAire © ${year}`;
    }
}
